import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI } from '../../../types/default-cloud-graph-conversation-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { ForgePioStackOverflowIcon, ForgePioStackOverflowSearchResultIcon } from './icon';

export const forgePioStackOverflowConfig: ThirdPartyConfig = {
	displayName: 'Stack Overflow by Pio',
	id: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
	resourceType: ProductResourceTypes3P.ForgePioStackOverflowDev,
	icon: get3PLogo(ForgePioStackOverflowIcon, 'ForgePioStackOverflow', 'medium'),
	searchResultIcon: get3PLogo(
		ForgePioStackOverflowSearchResultIcon,
		'ForgePioStackOverflow',
		'large',
	),
	integrationAri: 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Conversation,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
